import { EventEmitter } from '@angular/core';
import { CancelSessionDialogComponent } from '../../session/cancel-session-dialog/cancel-session-dialog.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JhiEventManager } from '../../../ng-jhipster/service';
import * as momenttz from "moment-timezone";
import * as i0 from "@angular/core";
import * as i1 from "@ng-bootstrap/ng-bootstrap";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "@angular/common";
import * as i4 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i5 from "../../../shared/calendar/add-to-calendar.component";
import * as i6 from "@fortawesome/angular-fontawesome";
import * as i7 from "@ctrl/ngx-emoji-mart/ngx-emoji";
import * as i8 from "../../session/schedule-session/schedule-session-coach/schedule-session-coach.component";
import * as i9 from "../../../shared/language/find-flag-code-from-key.pipe";
import * as i10 from "../../../shared/language/find-language-from-key.pipe";
function UpcomingSessionComponent_ng_container_0_ng_container_1_ng_container_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 17);
    i0.ɵɵelement(2, "use", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 19);
    i0.ɵɵtext(4, "Anonymous chat");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function UpcomingSessionComponent_ng_container_0_ng_container_1_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 20);
    i0.ɵɵelement(2, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "span", 22);
    i0.ɵɵtext(4, "Video call");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function UpcomingSessionComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1);
    i0.ɵɵelementStart(2, "h3", 2);
    i0.ɵɵtext(3, "Upcoming Session");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "add-to-calendar", 3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 4);
    i0.ɵɵelementStart(6, "div", 5);
    i0.ɵɵelement(7, "fa-icon", 6);
    i0.ɵɵelementStart(8, "span", 7);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "div", 4);
    i0.ɵɵelementStart(11, "div", 5);
    i0.ɵɵtemplate(12, UpcomingSessionComponent_ng_container_0_ng_container_1_ng_container_12_Template, 5, 0, "ng-container", 0);
    i0.ɵɵtemplate(13, UpcomingSessionComponent_ng_container_0_ng_container_1_ng_container_13_Template, 5, 0, "ng-container", 0);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 4);
    i0.ɵɵelementStart(15, "div", 8);
    i0.ɵɵelement(16, "fa-icon", 9);
    i0.ɵɵelement(17, "span", 10);
    i0.ɵɵelement(18, "ngx-emoji", 11);
    i0.ɵɵpipe(19, "findFlagCodeFromKey");
    i0.ɵɵelementStart(20, "span", 12);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "findLanguageFromKey");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 13);
    i0.ɵɵelementStart(24, "div", 14);
    i0.ɵɵelementStart(25, "button", 15);
    i0.ɵɵlistener("click", function UpcomingSessionComponent_ng_container_0_ng_container_1_Template_button_click_25_listener() { i0.ɵɵrestoreView(_r7); const ctx_r6 = i0.ɵɵnextContext(2); return ctx_r6.rescheduleSession(); });
    i0.ɵɵtext(26, "Reschedule");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(27, "button", 16);
    i0.ɵɵlistener("click", function UpcomingSessionComponent_ng_container_0_ng_container_1_Template_button_click_27_listener() { i0.ɵɵrestoreView(_r7); const ctx_r8 = i0.ɵɵnextContext(2); return ctx_r8.cancelSession("cancel"); });
    i0.ɵɵtext(28, "Cancel");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("session", ctx_r2.session);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r2.session.sessionStartTime.tz(ctx_r2.timezone).format("ddd, D MMM, hh:mm A (zz)") + ", " + ctx_r2.session.duration + " min");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r2.session.type === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r2.session.type === "video");
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate1("emoji", "flag-", i0.ɵɵpipeBind1(19, 6, ctx_r2.session.langKey), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(22, 8, ctx_r2.session.langKey));
} }
function UpcomingSessionComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelementStart(2, "div", 14);
    i0.ɵɵelementStart(3, "h3", 2);
    i0.ɵɵtext(4, "Upcoming Session");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 24);
    i0.ɵɵelementStart(6, "div", 25);
    i0.ɵɵtext(7, "No session booked");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 26);
    i0.ɵɵelementStart(9, "div", 27);
    i0.ɵɵelementStart(10, "button", 28);
    i0.ɵɵlistener("click", function UpcomingSessionComponent_ng_container_0_ng_container_2_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r10); const ctx_r9 = i0.ɵɵnextContext(2); return ctx_r9.openSessionScheduler(); });
    i0.ɵɵtext(11, "Book session");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("disabled", (ctx_r3.user == null ? null : ctx_r3.user.credits) === 0);
} }
function UpcomingSessionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, UpcomingSessionComponent_ng_container_0_ng_container_1_Template, 29, 10, "ng-container", 0);
    i0.ɵɵtemplate(2, UpcomingSessionComponent_ng_container_0_ng_container_2_Template, 12, 1, "ng-container", 0);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.session);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r0.session);
} }
function UpcomingSessionComponent_ng_container_1_h3_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 2);
    i0.ɵɵtext(1, "Upcoming Session");
    i0.ɵɵelementEnd();
} }
function UpcomingSessionComponent_ng_container_1_h3_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 36);
    i0.ɵɵtext(1, "Reschedule Session");
    i0.ɵɵelementEnd();
} }
function UpcomingSessionComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 23);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵtemplate(3, UpcomingSessionComponent_ng_container_1_h3_3_Template, 2, 0, "h3", 30);
    i0.ɵɵtemplate(4, UpcomingSessionComponent_ng_container_1_h3_4_Template, 2, 0, "h3", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 32);
    i0.ɵɵelementStart(6, "fa-icon", 33);
    i0.ɵɵlistener("click", function UpcomingSessionComponent_ng_container_1_Template_fa_icon_click_6_listener() { i0.ɵɵrestoreView(_r14); const ctx_r13 = i0.ɵɵnextContext(); return ctx_r13.closeSessionScheduler(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 34);
    i0.ɵɵelementStart(8, "div", 14);
    i0.ɵɵelementStart(9, "schedule-session-coach", 35);
    i0.ɵɵlistener("onCancel", function UpcomingSessionComponent_ng_container_1_Template_schedule_session_coach_onCancel_9_listener() { i0.ɵɵrestoreView(_r14); const ctx_r15 = i0.ɵɵnextContext(); return ctx_r15.closeSessionScheduler(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", !ctx_r1.session || !ctx_r1.showScheduler);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.session && ctx_r1.showScheduler);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("coach", ctx_r1.coach)("user", ctx_r1.user)("sessionId", ctx_r1.session == null ? null : ctx_r1.session.id)("sessionLanguage", ctx_r1.session == null ? null : ctx_r1.session.langKey);
} }
export class UpcomingSessionComponent {
    constructor(modalService, eventManager) {
        this.modalService = modalService;
        this.eventManager = eventManager;
        this.timezone = momenttz.tz.guess();
        this.onSessionSchedulerToggle = new EventEmitter();
    }
    set user(value) {
        var _a;
        if (((_a = this._user) === null || _a === void 0 ? void 0 : _a.id) !== (value === null || value === void 0 ? void 0 : value.id)) {
            this.closeSessionScheduler();
        }
        this._user = value;
    }
    get user() {
        return this._user;
    }
    set sessionToReschedule(value) {
        this._sessionToReschedule = value;
        if (value) {
            this.openSessionScheduler();
            this.session = value;
        }
        else {
            this.closeSessionScheduler();
        }
    }
    get sessionToReschedule() {
        return this._sessionToReschedule;
    }
    ngOnDestroy() {
        var _a, _b;
        (_a = this.sessionListModificationEventSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.rescheduleForCoachEventSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
    }
    ngOnInit() {
        this.sessionListModificationEventSubscription = this.eventManager.subscribe('sessionListModification', () => {
            this.closeSessionScheduler();
        });
        this.rescheduleForCoachEventSubscription = this.eventManager.subscribe("rescheduleForCoach", () => {
            this.openSessionScheduler();
        });
    }
    openSessionScheduler() {
        this.showScheduler = true;
        this.onSessionSchedulerToggle.emit(this.showScheduler);
    }
    closeSessionScheduler() {
        this.showScheduler = false;
        this.onSessionSchedulerToggle.emit(this.showScheduler);
    }
    cancelSession(type) {
        const modalRef = this.modalService.open(CancelSessionDialogComponent, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.sessionId = this.session.id;
        modalRef.componentInstance.type = type;
    }
    rescheduleSession() {
        this.cancelSession('reschedule');
    }
}
UpcomingSessionComponent.ɵfac = function UpcomingSessionComponent_Factory(t) { return new (t || UpcomingSessionComponent)(i0.ɵɵdirectiveInject(i1.NgbModal), i0.ɵɵdirectiveInject(i2.JhiEventManager)); };
UpcomingSessionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpcomingSessionComponent, selectors: [["upcoming-session"]], inputs: { coach: "coach", user: "user", session: "session", sessionToReschedule: "sessionToReschedule" }, outputs: { onSessionSchedulerToggle: "onSessionSchedulerToggle" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [1, "d-flex", "justify-content-between", "ml-3"], ["jhiTranslate", "sessionSchedule.header.upcomingSession"], [1, "desktop-calendar", 3, "session"], [1, "d-flex", "mt-2", "justify-content-start"], [1, "col", "text-dark", 2, "font-size", "1rem"], ["icon", "calendar"], [1, "ml-3"], [1, "d-flex", "col", "justify-content-start", "text-dark", 2, "font-size", "1rem"], ["icon", "globe"], ["jhiTranslate", "sessionSchedule.paragraph.language", 1, "ml-3", "mr-2"], [3, "emoji"], [1, "ml-1"], [1, "d-flex", "mt-4", "justify-content-start"], [1, "col"], ["jhiTranslate", "sessionSchedule.button.reschedule", 1, "btn", "btn-secondary", "mr-3", 3, "click"], ["jhiTranslate", "sessionSchedule.button.cancel", 1, "btn", "btn-link", 3, "click"], [1, "text-dark", 2, "height", "14px", "width", "14px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#text"], ["jhiTranslate", "inukaNgApp.inukaJourney.anonymousChat", 1, "ml-3"], [1, "text-dark", 2, "height", "16px", "width", "16px"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#video-call-dark"], ["jhiTranslate", "inukaNgApp.inukaJourney.videoCall", 1, "ml-3"], [1, "row", "justify-content-around"], [1, "row", "my-3", "mt-4", "justify-content-center"], ["jhiTranslate", "sessionSchedule.paragraph.noSessionBooked", 1, "col", "text-light", "text-center"], [1, "row", "justify-content-center"], [1, "col", "text-center"], ["jhiTranslate", "sessionSchedule.button.bookSession", 1, "btn", "btn-primary", 3, "disabled", "click"], [1, "col-10"], ["jhiTranslate", "sessionSchedule.header.upcomingSession", 4, "ngIf"], ["jhiTranslate", "sessionSchedule.header.rescheduleSession", 4, "ngIf"], [1, "col-2", "text-right"], ["icon", "times-circle", 1, "mt-3", "mr-3", 2, "cursor", "pointer", "color", "#8A9D98", 3, "click"], [1, "row", "mt-4", "justify-content-start"], [3, "coach", "user", "sessionId", "sessionLanguage", "onCancel"], ["jhiTranslate", "sessionSchedule.header.rescheduleSession"]], template: function UpcomingSessionComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, UpcomingSessionComponent_ng_container_0_Template, 3, 2, "ng-container", 0);
        i0.ɵɵtemplate(1, UpcomingSessionComponent_ng_container_1_Template, 10, 6, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.showScheduler);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showScheduler);
    } }, directives: [i3.NgIf, i4.JhiTranslateDirective, i5.AddToCalendarComponent, i6.FaIconComponent, i7.EmojiComponent, i8.ScheduleSessionCoachComponent], pipes: [i9.FindFlagCodeFromKeyPipe, i10.FindLanguageFromKeyPipe], styles: ["ngx-emoji[_ngcontent-%COMP%]{font-size:10px !important}"] });
